import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const items = document.querySelectorAll('.faq__item');

  if (!items.length) return;

  items.forEach((item) => {
    const question = item.querySelector('.faq__item-question');
    const answer = item.querySelector('.faq__item-answer');

    if (!question || !answer) return;

    answer.style.height = '0px';

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');

      items.forEach((el) => {
        el.classList.remove('is-active');
        const a = el.querySelector('.faq__item-answer');
        if (a) a.style.height = '0px';
      });

      if (!isActive) {
        item.classList.add('is-active');
        answer.style.height = answer.scrollHeight + 'px';
      }
    });
  });
});
